import React, { useEffect, useState, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { withRouter, Route, Switch } from 'react-router-dom';
import { Select, Button, Loader } from 'sa-ui';
import queryString from 'query-string';

import * as actions from '../../reportsActions';
import * as detailsActions from '../reportApplicationDetailsActions';

import messages from '../reportApplicationDetailsMessages';
import PerformanceStudentsComparative from '../../PerformanceStudentsComparative';
import { promisify } from '../../../app/actions';

import reportMessages from '../../reportsMessages';
import * as helpers from '../../reportHelpers';

import '../../ReportsCommon.scss';

import './ReportApplicationQuestionsContainer.scss';

function getExpand() {
  const params = queryString.parse(window.location.search.replace('?', ''));
  return !!params.expanded;
}

const ReportApplicationQuestionsContainer = props => {
  const [filter, setFilter] = useState(queryString.parse(window.location.search.replace('?', '')));
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(getExpand);

  useEffect(() => {
    setLoading(true);
    props.getGroups();
  }, []);

  async function selectFilter(
    idCSchool,
    idESCourse,
    idKnowledgeArea,
    idCurricularComponent,
    idCatalogingAbility,
    idBloom,
  ) {
    setFilter({ ...filter, idCSchool });
    setLoading(true);

    try {
      await props.getESGradeQuestionsDetail({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idKnowledgeArea,
        idCurricularComponent,
        idCatalogingAbility,
        idBloom,
      });

      await props.getFiltersQuestionsApplicationReport({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idKnowledgeArea,
        idCurricularComponent,
        idCatalogingAbility,
      });
    } finally {
      setLoading(false);
    }
  }

  async function FiltersQuestionsApplicationReport(idEvaluation) {
    setLoading(true);
    try {
      await props.getFiltersQuestionsApplicationReport({
        idEvaluation: props.idEvaluation,
      });
    } finally {
      // setLoading(false);
    }
  }

  useEffect(() => {
    FiltersQuestionsApplicationReport(props.idEvaluation);
  }, [props.idEvaluation]);

  useEffect(() => {
    selectFilter(
      filter.idCSchool,
      filter.idESCourse,
      filter.idKnowledgeArea,
      filter.idCurricularComponent,
      filter.idCatalogingAbility,
      filter.idBloom,
    );
  }, [
    filter.idCSchool,
    filter.idESCourse,
    filter.idKnowledgeArea,
    filter.idCurricularComponent,
    filter.idCatalogingAbility,
    filter.idBloom,
  ]);

  useEffect(() => {
    if (props.filtersQuestionsApplication && props.filtersQuestionsApplication.schools) {
      if (props.filtersQuestionsApplication.schools.length === 1) {
        setFilter({
          ...filter,
          idCSchool: props.filtersQuestionsApplication.schools[0].idCSchool,
        });
      }
    }
  }, [props.filtersQuestionsApplication]);

  function handleChangeSchool(event) {
    setFilter({
      ...filter,
      idCSchool: event.target.value,
      idESCourse: undefined,
      idKnowledgeArea: undefined,
      idCurricularComponent: undefined,
      idCatalogingAbility: undefined,
      idBloom: undefined,
    });
  }
  function handleChangeCourse(event) {
    setFilter({
      ...filter,
      idESCourse: event.target.value,
    });
  }
  function handleChangeKnowledgeArea(event) {
    setFilter({
      ...filter,
      idKnowledgeArea: event.target.value,
      idCurricularComponent: undefined,
    });
  }
  function handleChangeCurricularComponent(event) {
    setFilter({
      ...filter,
      idCurricularComponent: event.target.value,
    });
  }
  function handleChangeAbility(event) {
    setFilter({
      ...filter,
      idCatalogingAbility: event.target.value,
      idBloom: undefined,
    });
  }
  function handleChangeBloom(event) {
    setFilter({
      ...filter,
      idBloom: event.target.value,
    });
  }

  function clearFilters() {
    setFilter({
      idCSchool: undefined,
      idESCourse: undefined,
      idKnowledgeArea: undefined,
      idCurricularComponent: undefined,
      idCatalogingAbility: undefined,
      idBloom: undefined,
    });
  }

  const schoolOptions = helpers.getFASchoolOptions(props.filtersQuestionsApplication.schools);
  const classesOptions = helpers.getFAClassesOptions(props.filtersQuestionsApplication.courses);
  const knowledgeAreaOptions = helpers.getFAKnowledgeAreasOptions(
    props.filtersQuestionsApplication.knowledgeAreas,
  );
  const curricularComponentOptions = helpers.getFACurricularComponentOptions(
    props.filtersQuestionsApplication.curricularComponents,
  );
  const abilitiesOptions = helpers.getFAAbilitiesOptions(
    props.filtersQuestionsApplication.abilities,
  );
  const bloomsOptions = helpers.getFABloomsOptions(props.filtersQuestionsApplication.blooms);

  useImperativeHandle(props.forwardRef, () => ({
    getFilter: () => filter,
  }));

  useEffect(() => {
    if (filter.idCSchool) {
      setTimeout(() => window.dispatchEvent(new CustomEvent('app-ready')));
    }
  }, [filter.idCSchool]);

  return (
    <div className="report-application-questions--container">
      <Loader show={loading} />
      <h6 className="filter subtitle mt-3">
        <i className="pe-7s-filter" />
        <FormattedMessage {...messages.filters} />
        <FormattedMessage {...messages.clear}>
          {txt => (
            <button className="btn btn-primary btn-sm ml-3" onClick={clearFilters}>
              {txt}
            </button>
          )}
        </FormattedMessage>
      </h6>
      <Row className="align-items-center">
        <Col md={6}>
          <Select
            containerClassName="mt-0"
            nullable
            name="idCSchool"
            onChange={handleChangeSchool}
            value={filter.idCSchool}
            options={schoolOptions}
            placeholder={props.intl.formatMessage(reportMessages.school)}
          />
        </Col>
        <Col md={6}>
          <Select
            containerClassName="mt-0"
            disabled={!filter.idCSchool}
            nullable
            name="idESCourse"
            value={filter.idESCourse}
            onChange={handleChangeCourse}
            options={classesOptions}
            placeholder={props.intl.formatMessage(reportMessages.class)}
          />
        </Col>
      </Row>
      <Row className="align-items-center mt-3 mb-3">
        <Col md={6}>
          <Select
            containerClassName="mt-0"
            disabled={!filter.idCSchool}
            nullable
            name="idKnowledgeArea"
            onChange={handleChangeKnowledgeArea}
            value={filter.idKnowledgeArea}
            options={knowledgeAreaOptions}
            placeholder={props.intl.formatMessage(messages.knowledgeArea)}
          />
        </Col>
        <Col md={6}>
          <Select
            containerClassName="mt-0"
            disabled={!filter.idKnowledgeArea}
            nullable
            name="idCurricularComponent"
            value={filter.idCurricularComponent}
            onChange={handleChangeCurricularComponent}
            options={curricularComponentOptions}
            placeholder={props.intl.formatMessage(messages.curricularComponent)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Select
            containerClassName="mt-0"
            disabled={!filter.idCurricularComponent}
            nullable
            name="idCatalogingAbility"
            value={filter.idCatalogingAbility}
            onChange={handleChangeAbility}
            options={abilitiesOptions}
            placeholder={props.intl.formatMessage(messages.ability)}
          />
        </Col>
        {/* <Col md={6}>
          <Select
            containerClassName="mt-0"
            disabled={!filter.idCatalogingAbility}
            nullable
            name="idBloom"
            value={filter.idBloom}
            onChange={handleChangeBloom}
            options={bloomsOptions}
            placeholder={props.intl.formatMessage(messages.bloom)}
          />
        </Col> */}
      </Row>
      <br />
      <div id="divToPDF" className="divToPDF">
        <Row>
          {filter.idCSchool ? (
            <Col className="performance-column">
              <PerformanceStudentsComparative
                title={props.intl.formatMessage(
                  reportMessages.performanceQuestionsComparativeTitle,
                )}
                itens={props.questions}
                school={
                  props.evaluation.schools
                    ? props.evaluation.schools.find(s => s.idCSchool === filter.idCSchool)
                    : []
                }
                squareSize={{ maxWidth: '25%', flex: '0 0 20%' }}
                size={150}
                limit={15}
                filter={filter}
                idEvaluation={props.idEvaluation}
                expanded={expanded}
              />
            </Col>
          ) : (
            ''
          )}
        </Row>
      </div>
    </div>
  );
};

ReportApplicationQuestionsContainer.propTypes = {};

const mapStateToProps = ({ reports, reportApplicationDetails, app }, { match }) => ({
  ...reports,
  ...reportApplicationDetails,
  ...match.params,
  permission: app.permission,
});

export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps, promisify({ ...actions, ...detailsActions })),
)(ReportApplicationQuestionsContainer);
